// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq-accordion .card {\n  box-shadow: none;\n  background-color: transparent;\n}\n.faq-accordion .question-header {\n  background-color: transparent;\n  padding: 0;\n}\n.faq-accordion .question-header .not-collapsed .icon-collapsed {\n  display: none;\n}\n.faq-accordion .question-header .collapsed .icon-not-collapsed {\n  display: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
